import { render } from "./AyudaCita.vue?vue&type=template&id=7040459d&scoped=true"
import script from "./AyudaCita.vue?vue&type=script&lang=js"
export * from "./AyudaCita.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=7040459d&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7040459d"]])

export default __exports__